/**
 * Der Stil der Morgenmeditation, je Konto. (Ticket 3438, Alberts Wunsch vom 23.10.)
 *
 *   "tag"          Vorgabe: die tagesbezogene Meditation (Spiegel, Tugend, Handlung).
 *                  Fehlt das Feld, gilt sie — bestehende Konten ändern sich nie.
 *   "ewiges-sein"  „Erinnerung an das ewige Sein": ein fester Text, keine
 *                  Tagesdaten, kein Modell, dazu eine echte Stille für das
 *                  eigene Bild des Tages.
 *
 * ⚠️ EIN Besitzer der Namen, Beschriftungen und des Textes: Server (Auswahl,
 *    Erzeugung), Einstellungen und Tests lesen alles von hier.
 */

export const MEDITATIONS_STIL_FELD = "meditationStil";

export const MEDITATIONS_STILE = ["tag", "ewiges-sein"] as const;
export type MeditationsStil = (typeof MEDITATIONS_STILE)[number];

export const MEDITATIONS_STIL_VORGABE: MeditationsStil = "tag";

export const MEDITATIONS_STIL_TITEL = "Stil der Morgenmeditation";

export const MEDITATIONS_STIL_NAMEN: Readonly<Record<MeditationsStil, string>> = {
  tag: "Tag und Planung",
  "ewiges-sein": "Ewiges Sein",
};

export function istMeditationsStil(wert: unknown): wert is MeditationsStil {
  return typeof wert === "string" && (MEDITATIONS_STILE as readonly string[]).includes(wert);
}

/** Der gespeicherte Wert, gelesen: alles Unbekannte und Fehlende ist die Vorgabe. */
export function meditationsStilAus(wert: unknown): MeditationsStil {
  return istMeditationsStil(wert) ? wert : MEDITATIONS_STIL_VORGABE;
}

/** Sekunden der Stille für das eigene Bild des Tages. */
export const EWIGES_SEIN_STILLE_SEK = 30;

/**
 * Eine eigene Zeile zwischen zwei Absätzen: so viele Sekunden Stille ZUSÄTZLICH
 * zur Absatz-Stille (server/meditation-ton.ts liest sie, der Sprechtext nie).
 */
export function stilleMarke(sekunden: number): string {
  return `[Stille ${sekunden} s]`;
}

/**
 * Der feste Text. Rein, ohne Tagesdaten. Ein Absatz je Gedanke; die Leerzeilen
 * werden beim Vorlesen zu Stille (STILLE in meditation-ton.ts).
 */
export const EWIGES_SEIN_TEXT = [
  "Du wachst auf. Spüre die Unterlage unter dir. Spüre, wie sie dich trägt.",
  "Atme ein.",
  "Und atme aus.",
  "Und nun mache dir bewusst, wer du wirklich bist. Du bist nicht dein Körper. Du bist vollkommenes, ewiges Bewusstsein. Du warst immer da, und du wirst immer da sein.",
  "Dein Körper ist dein Werkzeug. Er dient dir, und er gehorcht dir. Nimm ihn jetzt liebevoll in Besitz, vom Scheitel bis in die Zehen, als etwas, das dir anvertraut ist und das dir treu dient.",
  "Sieh in Freude und in Dankbarkeit auf das, was gestern war. Alles, was geschehen ist, hat dich getragen, und alles, was du erlebt hast, gehört zu deinem Weg.",
  "Sieh in Freude und in Dankbarkeit auf das, was heute ist. Ein neuer Tag ist da, und er ist ein Geschenk.",
  "Nun sieh vor dir, was du dir für heute vorgenommen hast. Spüre, dass es schon da ist, und danke dafür.",
  stilleMarke(EWIGES_SEIN_STILLE_SEK),
  "Und nun gehe in Freude und in Dankbarkeit in diesen Tag.",
].join("\n\n");
